import React from 'react'
import { Registration as Index } from '../../components/templates'

const Registration: React.FC = () => {
  return <Index />
}

export default Registration
